/**
 * 全局路由守卫：登录校验 + 权限校验 + 用户信息预加载
 */
import store from '@/store'
import { getToken } from '@/utils/auth'

// 无需登录即可访问的白名单
const WHITE_LIST = ['/login', '/404']

export function setupRouterGuard(router) {
  router.beforeEach(async (to, from, next) => {
    const hasToken = !!getToken()

    // ---------- 未登录 ----------
    if (!hasToken) {
      if (WHITE_LIST.includes(to.path)) {
        next()
      } else {
        // 记录目标地址，登录后回跳
        next({
          path: '/login',
          query: to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {}
        })
      }
      return
    }

    // ---------- 已登录访问登录页 ----------
    if (to.path === '/login') {
      next({ path: '/' })
      return
    }

    // ---------- 已登录：确保用户信息已加载 ----------
    if (!store.state.user.loaded) {
      try {
        await store.dispatch('user/getUserInfo')
      } catch (e) {
        // token 失效或接口异常：清理并回到登录页
        store.dispatch('user/resetState')
        next({
          path: '/login',
          query: to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : {}
        })
        return
      }
    }

    // ---------- 页面级权限 ----------
    const required = to.meta?.permission
    if (required && !store.getters['user/hasPermission'](required)) {
      next({ path: '/403' })
      return
    }

    next()
  })

  // 标题统一在守卫后设置
  router.afterEach(to => {
    const base = '股票统计系统'
    document.title = to.meta?.title ? `${to.meta.title} · ${base}` : base
  })
}
